module.exports = __webpack_public_path__ + "static/mda-silver-21f4c4c2d2cd5a447b5908450eb7fda9.png";